var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVacancybig(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1220,
    height: 614,
    viewBox: "0 0 1220 614",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_241_1909)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 30C0 20.6812 0 16.0218 1.52241 12.3463C3.55229 7.44577 7.44577 3.55229 12.3463 1.52241C16.0218 0 20.6812 0 30 0H1190C1199.32 0 1203.98 0 1207.65 1.52241C1212.55 3.55229 1216.45 7.44577 1218.48 12.3463C1220 16.0218 1220 20.6812 1220 30V584C1220 593.319 1220 597.978 1218.48 601.654C1216.45 606.554 1212.55 610.448 1207.65 612.478C1203.98 614 1199.32 614 1190 614H30C20.6812 614 16.0218 614 12.3463 612.478C7.44577 610.448 3.55229 606.554 1.52241 601.654C0 597.978 0 593.319 0 584V30Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 30,
    width: 240,
    height: 28,
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 94,
    width: 408,
    height: 28,
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 142,
    width: 408,
    height: 28,
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 190,
    width: 631,
    height: 385,
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 732,
    y: 94,
    width: 408,
    height: 482,
    rx: 20,
    fill: "#F3F3F3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_241_1909"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1220,
    height: 614,
    rx: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVacancybig);
export default __webpack_public_path__ + "static/media/vacancybig.f32e52989fc5f078a6ee6e6dd5774881.svg";
export { ForwardRef as ReactComponent };